import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as userService from '../services/userService';
import { data } from 'autoprefixer';

// Async thunks
export const fetchAdminThunk = createAsyncThunk(
  'users/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      return await userService.fetchAdminList();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const signInUserThunk = createAsyncThunk(
  'users/signIn',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.signInAdmin(userData);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const addAppAdminOrAgentThunk = createAsyncThunk(
  'users/addAppAdminOrAgent',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.addAppAdminOrAgent(userData);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const getUserListByRoleThunk = createAsyncThunk(
  'users/getUserListByRole',
  async (appID, { rejectWithValue }) => {
    try {
      return await userService.fetchUserList(appID);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const getAppListThunk = createAsyncThunk(
  'users/getAppList',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.fetchAppList();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const addAppRegisterThunk = createAsyncThunk(
  'users/addAppRegister',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.addAppRegister(userData);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const updateAppThunk = createAsyncThunk(
  'users/updateAppdata',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.updateApp(userData);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const deleteAppThunk = createAsyncThunk(
  'users/deleteApp',
  async (id, { rejectWithValue }) => {
    try {
      return await userService.deleteApp(id);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const updateAppAdminOrAgentThunk = createAsyncThunk(
  'users/updateAppAdminOrAgentdata',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.updateAppAdminOrAgent(userData);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const addPaymentGatewayRegisterThunk = createAsyncThunk(
  'users/addPaymnetGatewayRegister',
  async (data, { rejectWithValue }) => {
    try {
      return await userService.addPaymentGatewayRegister(data);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const getGateWayListThunk = createAsyncThunk(
  'users/getGateWayList',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.fetchGateWayList();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const updateGateWayThunk = createAsyncThunk(
  'users/updateGateWaydata',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.updateGateway(userData);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const deleteGateWayThunk = createAsyncThunk(
  'users/deleteGateway',
  async (id, { rejectWithValue }) => {
    try {
      return await userService.deleteGateWay(id);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const getActiveGateWayListThunk = createAsyncThunk(
  'users/getactiveGateWayList',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.fetchActiveGateWayList();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const getadminDetailsThunk = createAsyncThunk(
  'users/getAdminDetails',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.fetchAdminDetails();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const getUnassignedAppListThunk = createAsyncThunk(
  'users/getUnAssignedAppList',
  async (userData, { rejectWithValue }) => {
    try {
      return await userService.fetchUnassignedAppList();
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const getAdminDetailsByIdThunk = createAsyncThunk(
  'users/getadminDetailsById',
  async (id, { rejectWithValue }) => {
    try {
      return await userService.fetchAdminDetailsById(id);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const deleteSubAdminThunk = createAsyncThunk(
  'users/deleteSubAdmin',
  async (id, { rejectWithValue }) => {
    try {
      return await userService.deleteSubAdmin(id);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const addUserHostRegisterThunk = createAsyncThunk(
  'users/addUserHostRegister',
  async (data, { rejectWithValue }) => {
    try {
      return await userService.addUserHost(data);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const updateUserHostThunk = createAsyncThunk(
  'users/updateUserHostdata',
  async ({id,formData}, { rejectWithValue }) => {
    try {
      return await userService.updateUserHost(formData,id);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const deleteUserHostThunk = createAsyncThunk(
  'users/deleteUserHost',
  async (id, { rejectWithValue }) => {
    try {
      return await userService.deleteUserHost(id);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
const userSlice = createSlice({
  name: 'users',
  initialState: {
    items: [],
    gatewayList: [],
    appList: [],
    activeGatewayList: [],
    unAssignedApp:[],
    adminDetails:{},
    data: {},
    data1: {},
    status: 'idle',
    uniqueCode: "",
    error: null,
    profile:{},
    submitted: false, // to track if the form was submitted
  },
  reducers: {
    clearError(state) {
      state.error = null;
    },
    resetSubmission(state) {
      state.submitted = false;
      state.status = 'idle';
    },
     clearUniqueCode: (state) => {
      state.uniqueCode = null;
    },
  },
  extraReducers: builder => {
    builder
      // fetchUsers
      .addCase(fetchAdminThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAdminThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(fetchAdminThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // addUser
      .addCase(signInUserThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(signInUserThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(signInUserThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // addAppAdminOrAgent
      .addCase(addAppAdminOrAgentThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(addAppAdminOrAgentThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
        state.uniqueCode="A123"
      })
      .addCase(addAppAdminOrAgentThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      .addCase(resetSubmission, state => {
        state.submitted = false;
        state.status = 'idle';   // if you want to reset status too
      })
      // getUserListByRole
      .addCase(getUserListByRoleThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getUserListByRoleThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(getUserListByRoleThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // getAppListThunk
      .addCase(getAppListThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getAppListThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.appList = payload?.data
        state.data = payload;
      })
      .addCase(getAppListThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // registerAppThunk
      .addCase(addAppRegisterThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(addAppRegisterThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.uniqueCode = "A12"
        state.data = payload;
      })
      .addCase(addAppRegisterThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // deleteAppThunk
      .addCase(deleteAppThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(deleteAppThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(deleteAppThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // updateadminThunk
      .addCase(updateAppAdminOrAgentThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateAppAdminOrAgentThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(updateAppAdminOrAgentThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // addpaymentgatewayThunk
      .addCase(addPaymentGatewayRegisterThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(addPaymentGatewayRegisterThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.data = payload;
      })
      .addCase(addPaymentGatewayRegisterThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // addpaymentgatewayThunk
      .addCase(getGateWayListThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getGateWayListThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.gatewayList = payload.data;
        state.data = payload;
      })
      .addCase(getGateWayListThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // updatepaymentgatewayThunk
      .addCase(updateGateWayThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateGateWayThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        // state.gatewayList = payload.data;
        state.data = payload;
      })
      .addCase(updateGateWayThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // deletepaymentgatewayThunk
      .addCase(deleteGateWayThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(deleteGateWayThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.gatewayList = payload.data;
        state.data = payload;
      })
      .addCase(deleteGateWayThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // getpaymentgatewayThunk
      .addCase(getActiveGateWayListThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getActiveGateWayListThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.activeGatewayList = payload.data;
        state.data = payload;
      })
      .addCase(getActiveGateWayListThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // updateappThunk
      .addCase(updateAppThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateAppThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.uniqueCode = "A12"
        state.data = payload;
      })
      .addCase(updateAppThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
        // getadminThunk
      .addCase(getadminDetailsThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getadminDetailsThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.profile = payload;
      })
      .addCase(getadminDetailsThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
         // getUnassignedThunk
      .addCase(getUnassignedAppListThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getUnassignedAppListThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.unAssignedApp = payload;
      })
      .addCase(getUnassignedAppListThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
            // getAdminDetailsByIdThunk
      .addCase(getAdminDetailsByIdThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getAdminDetailsByIdThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.adminDetails = payload;
      })
      .addCase(getAdminDetailsByIdThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
      // deleteSubAdminThunk
      .addCase(deleteSubAdminThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(deleteSubAdminThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
           state.uniqueCode = "A14"
        state.data = payload;
      })
      .addCase(deleteSubAdminThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
         // addUserHostThunk
      .addCase(addUserHostRegisterThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(addUserHostRegisterThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
          //  state.uniqueCode = "A14"
        state.data1 = payload;
      })
      .addCase(addUserHostRegisterThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
            // updateUserHostThunk
      .addCase(updateUserHostThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateUserHostThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
          //  state.uniqueCode = "A14"
        state.data1 = payload;
      })
      .addCase(updateUserHostThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
               // deleteUserHostThunk
      .addCase(deleteUserHostThunk.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(deleteUserHostThunk.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
          //  state.uniqueCode = "A14"
        state.data1 = payload;
      })
      .addCase(deleteUserHostThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      })
  }
});

export const { clearError, resetSubmission,clearUniqueCode } = userSlice.actions;

export default userSlice.reducer;
